import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { gbp, num } from "@/lib/format";
import { PageHeader } from "@/components/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const Table = ({ cols, rows, testId }) => (
  <div className="overflow-x-auto rounded-lg border bg-white">
    <table className="w-full min-w-[800px] text-sm" data-testid={testId}>
      <thead className="border-b bg-slate-50/80 text-left"><tr className="label-xs">{cols.map((c) => <th key={c.k} className={`px-4 py-3 ${c.right ? "text-right" : ""}`}>{c.label}</th>)}</tr></thead>
      <tbody>{rows.map((r) => (
        <tr key={r.code} className="border-b last:border-0 hover:bg-slate-50" data-testid={`${testId}-row-${r.code}`}>
          {cols.map((c) => <td key={c.k} className={`px-4 py-3 ${c.right ? "text-right tabular-nums" : ""}`}>{c.render ? c.render(r) : r[c.k]}</td>)}
        </tr>))}</tbody>
    </table>
  </div>
);

const code = (r) => <span className="font-mono text-xs font-semibold">{r.code}</span>;
const STORE_COLS = [
  { k: "code", label: "Code", render: code },
  { k: "name", label: "Store", render: (r) => <div><div className="font-semibold">{r.name}</div><div className="text-xs text-slate-500">{r.address}</div></div> },
  { k: "format", label: "Format" }, { k: "region", label: "Region" },
  { k: "city", label: "City", render: (r) => `${r.city}${r.postcode ? `, ${r.postcode}` : ""}` },
  { k: "concession_count", label: "Concessions", right: true },
  { k: "orders", label: "Orders", right: true, render: (r) => num(r.orders) },
  { k: "spend", label: "Spend", right: true, render: (r) => <b>{gbp(r.spend)}</b> },
];
const CONC_COLS = [
  { k: "code", label: "Code", render: code },
  { k: "name", label: "Operator / Brand", render: (r) => <div><div className="font-semibold">{r.name}</div><div className="text-xs text-slate-500">{r.department}</div></div> },
  { k: "type", label: "Type" }, { k: "floor", label: "Floor" }, { k: "store_name", label: "Host store" },
  { k: "orders", label: "Orders", right: true, render: (r) => num(r.orders) },
  { k: "spend", label: "Spend", right: true, render: (r) => <b>{gbp(r.spend)}</b> },
];

export default function Locations() {
  const [data, setData] = useState({ stores: [], concessions: [] });
  useEffect(() => { api.get("/locations").then((r) => setData(r.data)); }, []);
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Directory" title="Stores & concessions" />
      <Tabs defaultValue="stores">
        <TabsList><TabsTrigger value="stores" data-testid="locations-tab-stores">Stores ({data.stores.length})</TabsTrigger>
          <TabsTrigger value="concessions" data-testid="locations-tab-concessions">Concessions & franchises ({data.concessions.length})</TabsTrigger></TabsList>
        <TabsContent value="stores" className="mt-4"><Table cols={STORE_COLS} rows={data.stores} testId="stores-table" /></TabsContent>
        <TabsContent value="concessions" className="mt-4">
          {data.concessions.length ? <Table cols={CONC_COLS} rows={data.concessions} testId="concessions-table" />
            : <div className="rounded-lg border bg-white py-14 text-center text-sm text-slate-500" data-testid="concessions-empty">No concessions in your area</div>}
        </TabsContent>
      </Tabs>
    </div>
  );
}
